import { useQuery } from '@tanstack/react-query'
import { pendudukApi } from '../lib/client'
import { ApiResponse, PendudukStatistics } from '../../../shared-lib/types'

export function usePendudukStats() {
    return useQuery<ApiResponse<PendudukStatistics>>({
        queryKey: ['penduduk', 'statistics'],
        queryFn: async () => {
            try {
                return await pendudukApi.getStatistik()
            } catch (error) {
                // Create structured error response
                const errorResponse: ApiResponse<PendudukStatistics> = {
                    status: "error",
                    message: error instanceof Error ? error.message : "Gagal mengambil data statistik penduduk",
                    data: {
                        totalPenduduk: 0,
                        jumlahLakiLaki: 0,
                        jumlahPerempuan: 0,
                        persentaseLakiLaki: 0,
                        persentasePerempuan: 0,
                        totalKepalaKeluarga: 0,
                        persentaseKepalaKeluarga: 0,
                        rangeUmur: [],
                        perDusun: []
                    }
                }
                
                console.error('Error fetching penduduk statistics:', error)
                throw errorResponse
            }
        },
        staleTime: 5 * 60 * 1000, // 5 minutes
        retry: 3,
    })
}
